var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('global-header',{attrs:{"user-info":_vm.userInfo,"nav-icon":_vm.navIcon},on:{"item-click":_vm.itemClick,"clear":_vm.clearMsg}})}
var staticRenderFns = []

export { render, staticRenderFns }